<template>
  <div class="device-manage-page">
    <top-bar :topbarList="deviceManageTopBarList"></top-bar>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { deviceManageIndexMixins } from "@/mixins/deviceManageIndexMixins";

export default {
  mixins: [deviceManageIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.device-manage-page {
  height: 100%;
}
</style>
